<template>
  <div class="wishlists__type" role="radiogroup" aria-labelledby="wishlistType">
    <div id="wishlistType" class="wishlists__label-radio">List type *</div>
    <div class="wishlists__radio-group">
      <CdrRadio
        v-model="type"
        name="list-type"
        custom-value="public"
        data-ui="list_type"
        aria-labelledby="public"
        @change="emptyListType"
      >
        Public
      </CdrRadio>
      <CdrRadio
        v-model="type"
        name="list-type"
        custom-value="private"
        aria-labelledby="private"
        @change="listIsPrivate"
      >
        Private
      </CdrRadio>
    </div>
    <div v-if="type === 'public'" class="wishlists__privacy-policy">
      <CdrCheckbox v-model="privacyPolicy" data-ui="wishlists__privacy-policy" @change="listIsPublic">
        <p v-html="disclaimer" />
      </CdrCheckbox>
    </div>
  </div>
</template>

<script>
import { CdrRadio, CdrCheckbox } from '@rei/cedar';

export default {
  name: 'ListTypeComponent',
  components: {
    CdrRadio,
    CdrCheckbox,
  },
  props: {
    disclaimer: {
      type: String,
      default: '',
    },
    listType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      type: '',
      privacyPolicy: false,
    };
  },
  watch: {
    listType() {
      this.type = this.listType;
      this.privacyPolicy = this.listType === 'public';
    },
  },
  mounted() {
    this.type = this.listType ? this.listType : '';
    this.$emit('list-type-updated', this.listType === 'public' ? '' : false);
  },
  methods: {
    emptyListType() {
      this.$emit('list-type-updated', '');
    },
    listIsPrivate() {
      this.privacyPolicy = false;
      this.$emit('list-type-updated', false);
    },
    listIsPublic(event) {
      if (event.target.checked) {
        this.privacyPolicy = event.target.checked;
        this.$emit('list-type-updated', true);
      } else {
        this.privacyPolicy = false;
        this.emptyListType();
      }
    },
  },
};
</script>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.wishlists {
  &__type {
    display: block;
    align-items: center;
    margin-top: $cdr-space-one-and-a-half-x;
    padding: $cdr-space-one-x 0;
  }

  &__radio-group {
    display: flex;
    width: 100%;
    margin-top: 1.2rem;
  }

  &__privacy-policy {
    margin-bottom: $cdr-space-two-x;
    max-width: 527px;
    width: 100%;
    p {
      margin: 0;
      a {
        text-decoration: none;
      }
    }
  }
}
</style>
